import scraperApi from "api";

import { formDataToStructuredObject } from "utils/formDataUtils";

import OkResponse from "./OkResponse";
import { RouteErrors } from "routes/data-routes/types";


export async function cancelSubscriptionAction(): Promise<Response | RouteErrors.RouterActionError> {
  try {
    await scraperApi.subscription.cancel();
    return new OkResponse(); // all good
  } catch (error) {
    const err = error as any;
    return {
      error: {
        message: err.message || "Unexpected error when cancelling the subscription",
        meta: {
          shouldNotRetry: err.error_code === "user_outstanding_invoices"
        }
      }
    };
  }
}

export async function postCancellationSurveyAnswersAction({ request }: { request: Request }): Promise<Response | RouteErrors.RouterActionError> {
  const formDataObj = formDataToStructuredObject(await request.formData());
  try {
    await scraperApi.cancellationSurvey.saveAnswers(formDataObj);
  } catch (error) {
    // ignoring errors here, act as if everything was just fine letting users close the cancellation survey even if their answers haven't been saved
  }

  return new OkResponse();
}

export async function notPaidInvoicesLoader() {
    const notPaidInvoicesCount = await scraperApi.billing.invoices.getUnpaidInvoicesCount();
    return notPaidInvoicesCount || {};
}
